'use strict';

/**
 * WARNING: These TS constants, along with TS code, are used in the LESS CSS for auto generating LESS constants
 * via .delivery\scripts\generate-style-constants.ts.
 * 
 * @see {@link src\styles\styles.less}
 * @see {@link src\styles\readonly\_constants.less}
 * @see {@link .delivery\scripts\generate-style-constants.ts}
 */
export const ATT_CLASS_ON = 'att-on';

export const ATT_VARIABLE_TITLE_LEFT = '--title-left';
export const ATT_VARIABLE_TITLE_RIGHT = '--title-right';
export const ATT_VARIABLE_TITLE_WIDTH = '--title-width';
